import Cookies from './cookies'
import Menu from './menu'
import Submenu from './submenu'
import MenuManager from './open-menu'
import FiltersManager from './filters-manager'
import DetailsManager from './details-manager'
import MySwiper from './my-swiper'
import Checkout from './checkout'
import SelectFillManager from './select-fill'
import ShipFill from './shipping-method-fill'
import ValueDisplay from './value-display'
import Sum from './sum'
import Search from './search'
import DetailsInactiveOnDesktopManager from './details-inactive-desktop'
import FormManager from './form-manager'
import InputActionButtons from './input-action-buttons'
import OnScroll from './header-shadow'
import OnLoad from './on-load'
import AuthCheckout from './auth-checkout-fill'
import FindOptionManager from './find-option'
import SearchFocus from './search-focus'
import PopupMessage from './popup-message'
import PopupClear from './popup-clear'
import StripeDisplay from './stripe'
import BrowserCheck from './browser-check'
import LastInputTabManager from './last-input-tab'
import ActiveAction from './active-action'
import VariantUpdateManager from './variant-update-manager'
// import PageLoadAnimation from './page-load-animation'
// import DetailsBlur from './details-blur'
import PopupOnhash from './popup-onhash'
import ClickAvoidPropagation from './click-avoid-propagation'
import MBWait from './mbwait'
import AsyncPaymentChecks from './async-payment-checks'
import ChangeSubmit from './change-submit'
import VhRecalculate from './vh-recalculate'
import CountryPick from './country-pick'
import FormAutoFillLock from './form-auto-fill-lock'
import 'details-element-polyfill'

class App {
	constructor() {
		this.browserCheck = new BrowserCheck()
		if(this.browserCheck.isIE) {
			return;
		}
		this.cookies = new Cookies()
		this.vhRecalculate = new VhRecalculate()
		// this.menu = new Menu()
		// this.submenu = new Submenu()
		// this.menuManager = new MenuManager()
		this.filtersManager = new FiltersManager()
		this.DetailsManager = new DetailsManager()
		this.mySwiper = new MySwiper()
		this.stripe = new StripeDisplay()
		this.checkout = new Checkout()
		this.selectFillManager = new SelectFillManager()
		this.shipFill = new ShipFill()
		this.sum = new Sum()
		this.valueDisplay = new ValueDisplay()
		this.search = new Search()
		this.detailsInactiveOnDesktopManager = new DetailsInactiveOnDesktopManager()
		this.formManager = new FormManager()
		this.inputActionButtons = new InputActionButtons()
		this.OnScroll = new OnScroll()
		this.onLoad = new OnLoad()
		this.findOptionManager = new FindOptionManager()
		this.authCheckout = new AuthCheckout()
		this.searchFocus = new SearchFocus()
		this.popupMessage = new PopupMessage()
		this.clickAvoidPropagation = new ClickAvoidPropagation()
		this.popupClear = new PopupClear()
		this.lastInputTabManager = new LastInputTabManager()
		this.activeAction = new ActiveAction()
		this.variantUpdateManager = new VariantUpdateManager()
		// this.pageLoadAnimation = new PageLoadAnimation()
		// this.detailsBlur = new DetailsBlur()
		this.popupOnhash = new PopupOnhash()
		this.mbWait = new MBWait()
		this.asyncPaymentChecks = new AsyncPaymentChecks()
		this.changeSubmit = new ChangeSubmit()
		this.countryPick = new CountryPick()
		this.formAutoFillLock = new FormAutoFillLock()
	}
}

export default App